var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corporate-activities"},[_c('v-subtitle',{attrs:{"zh":"企业活动","en":"Corporate activities","type":"mini"}}),_c('v-activitys')],1)}
var staticRenderFns = []

export { render, staticRenderFns }